export enum NotificationType {
  SUCCESS,
  INFO,
  WARNING,
  ERROR,
  LOADING,
}

export interface Notification {
  type: NotificationType;
  message: string;
}
